import React, { Component } from 'react'
import { KeyboardSettings } from './KeyboardSettings.js'
import { ReactSVG } from 'react-svg'
import { isMobile, isDesktop } from '../../classes/Platform.js'
import { BnLabel1, BnLabel2 } from '../Label'
import { BnPage, BnSubpage } from '../Page'
import { BnForm, BnFormFields, BnFormFieldSeparator as Sep } from '../Form'
import { parsePhoneNumber, BnInputField, BnInputFieldSeparator } from '../TextInput'
import { KeyboardButton, KeyboardButton1 } from '../Keyboard'
import { delay, capitalize } from '../../classes/Util.js'
import { Keyboard } from '../Keyboard'
import { ChatGPT } from '../ChatGPT'
import { GetStarted, KeyboardLogin } from '../KeyboardLogin'
import Trash from '../../assets/Icons/Trash.svg'
import Twitter from '../../assets/Icons/Twitter.svg'
import Facebook from '../../assets/Icons/FBook.svg'
import LinkedIn from '../../assets/Icons/LnkIn.svg'
import TikTok from '../../assets/Icons/TikTok.svg'
import Copy from '../../assets/Icons/Copy.svg'
import Share from '../../assets/Icons/Share.svg'
import UserSaid from '../../assets/Icons/UserSaid.svg'
import ConnectSubscription from '../../assets/Icons/AISaid.svg'
import Create from '../../assets/Icons/Create.svg'
import Edit from '../../assets/Icons/SavedCommands.svg'
import Down from '../../assets/Icons/Down.svg'
import Right from '../../assets/Icons/Forward.svg'
import Pack from '../../assets/Icons/Pack.svg'
import Buy from '../../assets/Icons/Buy.svg'
import Profile from '../../assets/Icons/Profile.svg'
import Phone from '../../assets/Icons/Phone.svg'
import Google from '../../assets/Icons/Platforms/Google.svg'
import Apple from '../../assets/Icons/Platforms/Apple.svg'
import { canSignInWithApple } from '../../classes/AppleAuth.js'
import Windows from '../../assets/Icons/Platforms/Windows.svg'
import Spin from '../../assets/Icons/Spin.svg'
import AISaid from '../../assets/Icons/AISaid.svg'
import HomeNewUser from '../../assets/Icons/Guide0012x.png'
import Cross from '../../assets/Icons/Cross_1.svg'
import Update from '../../assets/Icons/Update.svg'
import HeroImage from '../../assets/Icons/HeroImage.png'
import ClickAwayListener from 'react-click-away-listener'
import UsageIcon from '../../assets/Icons/Usage.svg'
import TokenAlert from '../../assets/Icons/HomeAlert.svg'
import IntelliKeySmall from '../../assets/Icons/IntelliKeySml.svg'
import { WordPackPurchase } from '../Words'
import { Usage } from '../Usage'
import { SubscriptionProviders } from '../Subscriptions'
import { MacKeyboardSettings } from '../KeyboardSettings'
import { tokenCountForPack } from '../../classes/TokenPacks.js'
import phone from 'phone';
import { accountLinkErrorMessage, getAccountIdentity } from '../../classes/AccountAuth.js'
import {
  isIntelliKeyMacApp,
  isIntelliKeyWindowsApp
} from '../../classes/NativeEnvironment.js'
import { shouldShowMacSetup } from '../../classes/MacSetupStatus.js'
import { shouldShowKeyboardActivationGuide } from './keyboardActivationGuide'
import { HomeSubscriptionStatus, emptySubscriptionStatus } from './subscriptionStatus'
import {
  desktopDownloadFor,
  loadPublishedDesktopRelease
} from './desktopDownload'
import { writingAssistantLaunchOptionsForPage } from '../../classes/WritingAssistantLaunch.js'
import './index.css'

const TITLE = 'IntelliKey'

const SavedButtonTabs = props => {
  const { tabs, selection, select } = props
  return <div className='savedButtonTabs'>
           {
             tabs.map(tab => {
               const selected = tab.selector === selection
               const onClick = () => {
                 select(tab.selector)
               }
               return <SavedButtonTab icon={tab.icon} label={tab.label} onClick={onClick} selected={selected}/>
             })
           }
         </div>
}

const SavedButtonTab = props => {
  const { selected, icon, label, onClick } = props
  let className = 'savedButtonTab'
  if (selected) {
    className += ' savedButtonTabSelected'
  }
  return <div className={className} onClick={onClick}>
           <div className='savedButtonTabIcon'>
             <ReactSVG src={icon}/>
           </div>
           <div className='savedButtonTabLabel'>
             {label}
           </div>
         </div>
}


class SavedButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      busy: false
    }
  }
  render() {
    const { button } = this.props
    const { id, instruction, category } = button
    const { busy } = this.state
    const deleteButton = async () => {
      await this.props.me.deleteButton(button)
    }
    const shareButton = async () => {
      debugger
      await this.props.me.shareButton(button)
    }
    return <div className='savedButton'>
             <div className='savedButtonLeft'>
               <div className='savedButtonIcon'>
                 <ReactSVG src={UserSaid}/>
               </div>
               <div className='savedButtonLabel'>
                 {instruction}
               </div>
             </div>
             <div className='savedButtonRight'>
               <KeyboardButton1 className='savedButtonDelete' icon={Trash} action={deleteButton}/>
               <KeyboardButton1 className='savedButtonShare'icon={Share} action={shareButton}/>
               </div>
           </div>
  }
}

class SavedButtonCategory extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }
  renderButtons() {
    return this.props.buttons.map(button => {
      return <SavedButton me={this.props.me} button={button}/>
    })
  }
  toggleMenu = () => {
    this.setState({
      open: !this.state.open
    })
  }
  render() {
    const { open } = this.state
    return <div className={'savedButtonCategory' + (open ? ' savedButtonCategoryOpen' : '')}>
             <div className='savedButtonCategoryMenu' onClick={this.toggleMenu}>
               <div className='savedButtonIcon'>
                 <ReactSVG src={open ? Down : Right}/>
                 </div>
               <div className='savedButtonLabel'>
                 {this.props.category}
               </div>
             </div>
             {open && <div className='savedButtonCategoryButtons'>
                         {this.renderButtons()}
                       </div>}
           </div>
  }
}

export const HomeInput = props => {
  const { form, formErr, onChange, name, type, autocomplete, label, sublabel} = props
  let className = 'homeButton'
  if (props.className) className += ' ' + props.className
  return <div className={className}>
           <div className='homeButtonLabels'>
             <div className='homeButtonLabel'>{label}</div>
             <div className='homeButtonSublabel'>{sublabel}</div>
           </div>
           <BnInputField name={name} label={''} formErr={formErr} form={form} type={type} onChange={onChange} autoComplete={autocomplete} busy={form.busy}/>
         </div>
}

const HomeLabel = props => {
  const { label, content } = props
  return <div className='homeButton'>
           <div className='homeButtonLabels'>
             <div className='homeButtonLabel'>{label}</div>
           </div>
           {content}
         </div>
  }

const AccountIdentityField = props => {
  const { label, linked, value } = props
  return <div className={'accountIdentityField ' + (linked ? 'accountIdentityLinked' : 'accountIdentityNotLinked')}>
           <div className='accountIdentityHeading'>
             <div className='homeButtonLabel'>{label}</div>
             <div className='accountIdentityStatus'>{linked ? 'Linked' : 'Not linked'}</div>
           </div>
           <div className='accountIdentityValue'>{value || 'Not linked'}</div>
         </div>
}


export class HomeButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      busy: false
    }    
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  onClick = async () => {
    if (this.props.disabled || this.busy || this.state.busy || this.props.busy) return
    this.busy = true
    this.setState({ busy: true })
    try {
      if (this.props.action) await this.props.action()
    } finally {
      this.busy = false
      if (this.mounted) this.setState({ busy: false })
    }
  }
  
  render() {
    const props = this.props
    const busy = this.props.busy || this.state.busy
    const  right = (busy) ? <ReactSVG src={Spin}/> : props.right
    let className = 'homeButton'
    if (props.className) {
      className += ' ' + props.className
    }
    return <div className={className}>
             <div className='homeButtonLabels'>
               <div className='homeButtonLabel'>{props.label}</div>
               <div className='homeButtonSublabel'>{props.sublabel}</div>
             </div>
             <div className='homeButtonButton' onClick={this.onClick} aria-disabled={props.disabled || undefined}>
               <div className='homeButtonButtonIcon'>
                 <ReactSVG src={props.icon}/>
               </div>
               <div className='homeButtonButtonLabel'>
                 {props.buttonLabel}
               </div>
             </div>
             <div className={'homeButtonRight' + (busy ? ' homeButtonRightBusy' : '')}>
               {right}
             </div>
           </div>
  }
}

const formatAmount = amount => {
  if (amount > 1000000) {
    return Math.round(amount / 1000000).toFixed(1) + 'M'
  }
  if (amount > 1000) {
    return Math.round(amount/1000) + 'K'
  }
  return amount
}

const Stat = props => {
  let className = 'keyboardHomeStat'
  if (props.className) {
    className += ' ' + props.className
  }
  return <div className={className}>
           <div className='keyboardHomeStatLabel'>
             {props.label}
             </div>
           <div className='keyboardHomeStatValue'>
             {formatAmount(props.value)}
             </div>
           </div>
}


export class Account extends BnSubpage {

  componentDidMount() {
    this.accountMounted = true
    this.props.me.getReferralCode().then(code => {
      if (!this.accountMounted) return
      this.set('referralCode', code)
      this.forceUpdate()
    })
    const { countryCode } = parsePhoneNumber(this.props.me.self.phoneNumber)
    this.set('countryCode', countryCode)
    this.set('phoneNumber', this.props.me.self.phoneNumber)
    this.set('email', this.props.me.self.email)
    this.authSub = this.props.me.observeSelf().subscribe(authUser => {
      const changed = this.state.authUser?.uid !== authUser?.uid
      this.setState({ authUser, ...(changed ? { confirmLink: null, linkError: null } : {}) })
      if (authUser) this.props.me.getAccountLinks?.().then(links => {
        if (this.accountMounted !== false && this.props.me.firebase.auth().currentUser?.uid === authUser.uid) {
          this.setState({ linkedIdentities: links.identities || [] })
        }
      }).catch(() => {})
    })
  }

  componentWillUnmount() {
    this.accountMounted = false
    if (this.authSub) {
      this.authSub.unsubscribe()
      this.authSub = null
    }
  }

  updatePhoneNumber = async () => {
    const form = this.getForm()
    let phoneNumber = form.phoneNumber
    let countryCode = form.countryCode
    const converted = phone(phoneNumber);
    if (!converted.length) {
      formErr = {field: 'phoneNumber', message: 'Invalid phone number.'};
      this.forceUpdate()
      return
    } else {
      phoneNumber = converted[0];
    }
    await this.props.me.updatePhoneNumber(phoneNumber)
  }

  signOut = async () => {
    this.setState({ signOutError: null })
    try {
      await this.props.me.signOut()
    } catch (error) {
      this.setState({ signOutError: error.message || 'Could not sign out. Please try again.' })
    }
  }

  signUp = async () => {
    debugger
    const back = this.back
    this.setState({
      subpage: () => <KeyboardLogin me={this.props.me} safeArea={true} back={back}/>
    })
  }

  refreshIdentity = async () => {
    const authUser = await this.props.me.refreshCurrentUser()
    const links = await this.props.me.getAccountLinks?.()
    if (this.accountMounted === false || this.props.me.firebase.auth().currentUser?.uid !== authUser?.uid) return null
    this.setState({ authUser, linkedIdentities: links?.identities || [], linkError: null })
    this.props.me.getAllButtons?.().then(({ buttons }) => {
      if (this.props.me.firebase.auth().currentUser?.uid === authUser.uid) this.props.me.sendButtons(buttons)
    }).catch(() => {})
    return authUser
  }

  linkGoogle = async () => {
    return this.linkAccountProvider('google')
  }

  linkApple = async () => {
    return this.linkAccountProvider('apple')
  }

  linkAccountProvider = async provider => {
    if (this.linkingAccount) return
    this.linkingAccount = true
    this.setState({ linkError: null })
    const expectedUID = this.props.me.firebase.auth().currentUser?.uid
    const current = () => this.accountMounted !== false && this.props.me.firebase.auth().currentUser?.uid === expectedUID
    try {
      const method = provider === 'apple' ? 'signInWithApple' : 'signInWithGoogle'
      const result = await this.props.me[method](false)
      if (!current()) return
      if (!result) return
      if (result.error) throw result.error
      const authUser = await this.refreshIdentity()
      if (!expectedUID || authUser?.uid !== expectedUID) {
        const error = new Error('Linking did not preserve the current IntelliKey account.')
        error.code = 'auth/user-mismatch'
        throw error
      }
    } catch (error) {
      if (current()) this.setState({
        linkError: accountLinkErrorMessage(error, provider)
      })
    } finally {
      this.linkingAccount = false
    }
  }

  closePhoneLink = () => {
    this.setState({ subpage: null })
  }

  finishPhoneLink = async () => {
    await this.refreshIdentity()
    this.setState({ subpage: null, linkError: null })
  }

  linkPhone = () => {
    if (!this.props.me.firebase.auth().currentUser || this.linkingAccount) return
    this.setState({
      linkError: null,
      subpage: () => <KeyboardLogin
        me={this.props.me}
        safeArea={true}
        back={this.closePhoneLink}
        next={this.finishPhoneLink}
        linkPhoneOnly={true}/>
    })
  }

  deleteAccount = async () => {
    if (!this.state.confirmDeleteAccount) {
      this.setState({
        confirmDeleteAccount: true
      })
    } else {
      this.setState({ deleteError: null })
      try {
        const deleted = await this.props.me.deleteAccount()
        if (deleted === false) this.setState({ confirmDeleteAccount: false })
      } catch (error) {
        this.setState({ deleteError: error.message || 'Could not delete your account.' })
      }
    }
  }

  cancelDeleteAccount = () => {
    this.setState({
      confirmDeleteAccount: false
    })
  }

  copyField = async (field) => {
    const form = this.getForm()
    navigator.clipboard.writeText(form[field])
    await delay(0.5)
  }

  renderContent() {
    let deleteAccountClass = 'keyboardHomeAccountDelete'
    let deleteAccountLabel = 'Delete Account'
    if (this.state.confirmDeleteAccount) {
      deleteAccountClass += ' keyboardHomeAccountDeleteConfirm'
      deleteAccountLabel = 'Confirm Delete Account'
    }
    const authUser = this.state.authUser || this.props.me.firebase.auth().currentUser || this.props.me.self
    const identity = getAccountIdentity(authUser, this.state.linkedIdentities)
    const hasAccount = !identity.isAnonymous
    return <div className='bnSubpageContent keyboardHome keyboardHomeAccountPage'>
             <div className='keyboardHomeAccountSpacer0'/>
             <div className='accountIdentity'>
               {(canSignInWithApple() || identity.appleLinked) && <AccountIdentityField
                 label='Apple account' linked={identity.appleLinked} value={identity.appleLinked ? 'Sign in with Apple' : ''}/>}
               {canSignInWithApple() && <HomeButton
                 className='accountIdentityAction accountAppleLink'
                 label='add Apple sign-in'
                 buttonLabel='Link Apple account'
                 action={this.linkApple}
                 icon={Apple}/>}
               <AccountIdentityField label='Email address' linked={identity.emailLinked} value={identity.email}/>
               {<HomeButton
                 className='accountIdentityAction accountGoogleLink'
                 label='add an email sign-in'
                 buttonLabel='Link Google account'
                 action={this.linkGoogle}
                 icon={Google}/>}
               <AccountIdentityField label='Phone number' linked={identity.phoneLinked} value={identity.phoneNumber}/>
               {<HomeButton
                 className='accountIdentityAction'
                 label='add phone sign-in'
                 buttonLabel='Link phone number'
                 action={this.linkPhone}
                 icon={Phone}/>}
               {this.state.linkError && <div className='accountIdentityError'>{this.state.linkError}</div>}
             </div>
             <div className='keyboardHomeAccountSpacer1'/>
             <div className='keyboardHomePhone'>
              <HomeInput label='your referral code' form={this.getForm()} name='referralCode' className='inputReferralCode' sublabel='Share this referral code to get free token packs'/>
                <KeyboardButton label='Copy' icon={Copy} action={() => this.copyField('referralCode')}/>
              </div>
             <div className='keyboardHomeAccountSpacer1'/>
             <KeyboardSettings me={this.props.me} getSetting={this.props.getSetting} setSetting={this.props.setSetting}
               toggleSetting={this.props.toggleSetting} settingsError={this.props.settingsError}/>
             
             <div className='keyboardHomeAccountSpacer1'/>
             <HomeButton label='sign out of your account' buttonLabel='Sign out' action={this.signOut} icon={Profile}/>
             {this.state.signOutError && <div className='accountIdentityError' role='alert'>{this.state.signOutError}</div>}
             {hasAccount && <div className='keyboardHomeAccountSpacer2'/>}
             {hasAccount &&
              <ClickAwayListener onClickAway={this.cancelDeleteAccount}>
                <div className={deleteAccountClass}>
                  <HomeButton
                    icon={Cross} label='permanently close account'
                    buttonLabel={deleteAccountLabel} action={this.deleteAccount}/>
                  <div className='keyboardHomeAccountDeleteWarning'>
                    All your data will be permanently deleted from our servers. To use IntelliKey again, you’ll need to create a new account.
                  </div>
                  {this.state.deleteError && <div className='accountIdentityError' role='alert'>{this.state.deleteError}</div>}
                </div>
                </ClickAwayListener>}
             </div>
  }
}

class MacSetupPage extends BnSubpage {
  renderContent() {
    return <MacKeyboardSettings status={this.props.status} me={this.props.me}/>
  }
}


export class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      wordsUsed: 0,
      wordsPurchased: 0,
      buttons: [],
      desktopReleases: {}
    }
  }

  render() {
    const subpage = this.props.handoffEditor || (this.state.subpage ? this.state.subpage() : null)
    const content = this.renderContent()
    return  <BnPage me={this.props.me} subpage={subpage} safeArea={true}>
             {content}
             </BnPage>
           
  }

  back = () => {
    this.setState({
      subpage: null
    })
    if (this.statusMonitor) this.statusMonitor.refresh()
  }

  account = async () => {
    this.setState({
      subpage: () => <Account title={"Account"}
                              me={this.props.me}
                              getSetting={this.props.getSetting}
                              toggleSetting={this.props.toggleSetting}
                              setSetting={this.props.setSetting}
                              settingsError={this.props.settingsError}
                              back={this.back}/>
    })
  }


  buy = async () => {
    if (this.props.me.isSignedInAnonymously()) {
      this.signUp()
      return
    }
    this.setState({
      subpage: () => <WordPackPurchase title={"Token Packs"}
                                       getSetting={this.props.getSetting}
                                       toggleSetting={this.props.toggleSetting}
                                       me={this.props.me} back={this.back} available={formatAmount(Math.max(this.state.wordsPurchased - this.state.wordsUsed, 0))}/>
    })
  }

  openUsage = () => {
    this.setState({
      subpage: () => <Usage title='Usage' me={this.props.me} back={this.back} safeArea />
    })
  }

  openSubscriptions = () => {
    this.setState({
      subpage: () => <SubscriptionProviders
        title='Subscriptions'
        me={this.props.me}
        back={this.back}
        safeArea
        desktopReleases={this.state.desktopReleases} />
    })
  }

  openMacSetup = () => {
    this.setState({
      subpage: () => <MacSetupPage
        me={this.props.me}
        status={this.props.macSetupStatus}
        back={this.back}/>
    })
  }

  shareKeyboardOutput = async output => {
  }

  openWritingAssistant = ({
    startTextFieldDictation = false,
    focusTextFieldAtEnd = false
  } = {}) => {
    this.setState({
      subpage: () => <Keyboard me={this.props.me}
                               onNotENoughTokens={this.onNotEnoughTokens}
                               isWritingAssistant={true}
                               saveCommandButtonType='edit'
                               startTextFieldDictation={startTextFieldDictation}
                               focusTextFieldAtEnd={focusTextFieldAtEnd}
                               cancelKeyboardOutput={this.back}
                               sendKeyboardOutput={this.shareKeyboardOutput}
                     />

    })
  }

  openModels = () => {
    this.openChat()
  }

  openBaseModels = () => {
    this.openChat({
      isBaseModel: true
    })
  }

  openChat = (opts) => {
    this.setState({
      subpage: () => <ChatGPT me={this.props.me} back={this.back}
                              isOpenAI={opts && opts.isOpenAI}
                              isBaseModel={opts && opts.isBaseModel || this.props.me.isBaseModel()}
                              observeChatMessages={this.props.me.observeChatMessages}
                              observeTaskMessages={this.props.me.observeTaskMessages}
                              observeChatThreads={this.props.me.observeChatThreads}
                              observeTasks={this.props.me.observeTasks}
                              deleteChatMessage={this.props.me.deleteChatMessage}
                              getHistory={this.props.me.getHistory}
                              getTaskHistory={this.props.me.getTaskHistory}
                              getThreadsHistory={this.props.me.getThreadsHistory}
                              searchChatMessages={this.props.me.searchChatMessages}
                              streamChat={this.props.me.streamChat}
                     />
    })
  }

  renderContent() {
    let openLinkedIn, openTwitter, openFacebook, openTikTok
    const showMacSetup = isIntelliKeyMacApp() && shouldShowMacSetup(this.props.macSetupStatus)
    const desktopDownload = desktopDownloadFor({
      navigatorLike: typeof navigator === 'undefined' ? undefined : navigator,
      isMacApp: isIntelliKeyMacApp(),
      isWindowsApp: isIntelliKeyWindowsApp(),
      desktopReleases: this.state.desktopReleases
    })
    if (false) {
      openLinkedIn = () => {
        this.props.me.openWindow('https://www.linkedin.com/company/badnano/')
      }
      openTwitter = () => {
        this.props.me.openWindow('https://twitter.com/intellikey_ai')
      }
      openFacebook = () => {
        this.props.me.openWindow('https://facebook.com/groups/IntelliKey')
      }
      openTikTok = () => {
        this.props.me.openWindow('https://tiktok.com/@intellikey.ai')
      }
    }
    const s = (window.innerWidth - 20) / 240
    let style = {
      transform: `scale(${s},${s})`,
    }
    let available = Math.max(this.state.wordsPurchased - this.state.wordsUsed, 0)
    if (isNaN(available)) {
      debugger
    }
    let className = 'keyboardWindow keyboardHome'
    let isLow = available < 1000
    let isLowMessage
    if (available === 0) {
      isLowMessage = 'You\'re out of tokens!\nYou can purchase additional Token Packs for your account below.'
    } else if (isLow) {
      isLowMessage = 'Tokens are running low! You can purchase additional Token Packs for your account below.'
    }
    if (isLowMessage) {
      className += ' keyboardHomeWordPacksLowStatus'
    }
    const subscriptionStatus = this.state.subscriptionStatus || emptySubscriptionStatus
    const subscriptionStatusClass = ' subscriptionStatus' + capitalize(subscriptionStatus.indicator)

    let blurbStyle = {
      fontSize: (Math.min(window.innerWidth, 600)*0.5 / 240) * 16
    }

    let askLabel = 'reliable answers'
    let askButtonLabel = 'Ask'
    let title = TITLE

    return <div className={className}>
             <div className='keyboardHomeHeader'>
               <div className='keyboardHeaderTitle'>{title}</div>
             </div>
             <div className='keyboardHomeTop'>
               <div className='keyboardHomeShape'>
<svg id="HeroMask" data-name="Hero" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 558 203">
	<defs>
		<clipPath id="shape">
			<polygon points=".359 43.07 65.272 155.504 37.969 202.795 222.403 202.795 130.186 43.07 .359 43.07" />
			<polygon points="394.23 154.515 471.333 21.328 281.753 21.328 293.949 .205 115.766 .205 204.858 154.515 394.23 154.515" />			
		</clipPath>
	</defs>

  <image href={HeroImage} clipPath="url(#shape)" />
			
	<g className="heroMaskLeft">
	  <polygon points=".359 43.07 65.272 155.504 37.969 202.795 222.403 202.795 130.186 43.07 .359 43.07" style={{fill:"#086461;"}} opacity="0.9" />
	</g>
			
	<g className="heroMaskMiddle">
	  <polygon points="394.23 154.515 471.333 21.328 281.753 21.328 293.949 .205 115.766 .205 204.858 154.515 394.23 154.515" style={{fill:"#086461;"}} opacity="0.9" />
	</g>
			
  <g className={"heroMaskRight" + subscriptionStatusClass}>
	  <polygon points="481.15 21.408 404.301 154.515 558 154.515 481.15 21.408" style={{fill:"#0A807E;"}} />
          <g transform='translate(481.15, 148.515)'>
                      <text className='subscriptionStatusProvider'>{subscriptionStatus.name}</text>
                       <text className='subscriptionStatusDescription'>{subscriptionStatus.label}</text>
                     </g>
	</g>
</svg>
                 <div className='keyboardHomeStats'>
                   <Stat className='statAvailable' label='tokens available' value={available}/>
                   <Stat className='statUsed' label='used' value={this.state.wordsUsed || 0}/>
                   <Stat className='statPurchased' label={this.state.nonFree ? 'purchased' : 'free'} value={this.state.wordsPurchased || 0}/>

                 </div>
               </div>
             </div>
             <div className='intellikeyLinks' style={{display: 'none'}}>
               {openFacebook && <div className='facebookLink' onClick={openFacebook}><ReactSVG src={Facebook}/></div>}
               {openTwitter && <div className='facebookLink' onClick={openTwitter}><ReactSVG src={Twitter}/></div>}
               {openTikTok && <div className='facebookLink' onClick={openTikTok}><ReactSVG src={TikTok}/></div>}
             </div>
             <div className='keyboardHomeBottom'>
               <div className='keyboardHomeButtons'>
                 {desktopDownload &&
                  <HomeButton
                    className='intellikeyDesktopDownload'
                    icon={desktopDownload.platform === 'windows' ? Windows : Apple}
                    label={desktopDownload.label}
                    buttonLabel='Download'
                    action={() => window.location.assign(desktopDownload.url)}/>}
                 {isLowMessage && <div key='lowBro' className='keyboardHomeWordPacksLow'>
                                    <div className='keyboardHomeWordPacksLowIcon'>
                                    <ReactSVG src={TokenAlert}/>
                                    </div>
                                    <div className='keyboardHomeWordPacksLowMessage'>
                                      {isLowMessage}
                                    </div>
                                  </div>}
                 {shouldShowKeyboardActivationGuide({
                   isNative: this.props.me.isNative(),
                   isKeyboardActive: this.props.isKeyboardActive,
                   isDesktop: isDesktop(),
                   isMacApp: isIntelliKeyMacApp()
                 }) && <div key='activate' className='keyboardHomeKeyboardActivate'>
                                                    <div className='keyboardHomeWordPacksLowIcon'>
                                                      <ReactSVG src={AISaid}/>
                                                    </div>
                                                    <img src={HomeNewUser}/>
                                                    <div className='keyboardHomeKeyboardActivateBlurb' style={blurbStyle}>
                                                      Select IntelliKey by tapping the Globe icon on your keyboard.
                                                      </div>
                                       </div>}
                 {showMacSetup && <HomeButton
                   icon={IntelliKeySmall}
                   label='INTELLIKEY'
                   buttonLabel='Setup'
                   action={this.openMacSetup}/>}
                 {false &&
                  <HomeButton icon={AISaid} label={askLabel} buttonLabel={askButtonLabel} action={this.openChat}/>}
                 <HomeButton icon={Create} label='editing assistance' buttonLabel='Edit' action={this.openWritingAssistant}/>
                 <HomeButton className={'wordPackBuyButton' + (
                               isLowMessage ? ' wordPackBuyButtonLow' : '')}  icon={Buy} label={'add tokens to your account'} buttonLabel='Token Packs' action={this.buy}/>
                 <HomeButton icon={ConnectSubscription} label='use an existing ai subscription' buttonLabel='Connect Subscription' action={this.openSubscriptions}/>
                 <HomeButton className='homeUsageButton' icon={UsageIcon} label={'keyboard activity, tokens, and cost'} buttonLabel='Usage' action={this.openUsage}/>
                 {this.props.me && <HomeButton icon={Profile} label={'view your account'} buttonLabel='Account' action={this.account}/>}
               </div>
               <div className='keyboardHomeSavedButtons'>
                 <div className='homeButtonLabel keyboardHomeSavedButtonsLabel'>Saved</div>
                 {this.renderSavedButtonTabs()}
               </div>
             </div>
           </div>
  }

  renderSavedButtonTabs() {
    const tabs = [
      {
        icon: Edit,
        label: 'Editing',
        selector: 'edit'
      }
    ]
    return <div className='savedButtonTabsContainer'>
             <SavedButtonTabs tabs={tabs} selection='edit' select={() => {}}/>
             <div className='keyboardHomeSavedButtonsList'>
               {this.renderSavedButtons(this.state.buttons)}
             </div>
           </div>
  }

  renderSavedButtons(buttons) {
    const Cats = {}
    for (const button of buttons) {
      const { id, instruction, category, busy } = button
      if (!Cats[category]) {
        Cats[category] = [button]
      } else {
        Cats[category].push(button)
      }
    }
    const cats = Object.keys(Cats)
    cats.sort()
    return cats.map(cat => {
      const buttons = Cats[cat]
      return <SavedButtonCategory category={cat} me={this.props.me} buttons={buttons}/>
    })
  }

  selectPage = page => {
    const writingAssistantOptions = writingAssistantLaunchOptionsForPage(page)
    if (writingAssistantOptions) {
      this.openWritingAssistant(writingAssistantOptions)
    } else if (page === 'ask') {
      this.openChat()
    } else {
      this.back()
    }
  }

  componentDidMount() {
    this.desktopReleaseMounted = true
    this.props.onCreate(this)
    const download = desktopDownloadFor({
      navigatorLike: typeof navigator === 'undefined' ? undefined : navigator,
      isMacApp: isIntelliKeyMacApp(),
      isWindowsApp: isIntelliKeyWindowsApp()
    })
    if (download) {
      loadPublishedDesktopRelease(this.props.me.firebase, download.platform)
        .then(release => {
          if (!this.desktopReleaseMounted || !release) return
          this.setState({
            desktopReleases: {
              ...this.state.desktopReleases,
              [release.platform]: release
            }
          })
        })
        .catch(() => {})
    }
    this.psub = this.props.me.observeProfile(this.props.uid).subscribe(data => {
      const { uid, displayName, email, profileImage, phoneNumber, tokensPurchased } = data
      this.setState({
        profile: {
          uid, displayName, email, profileImage, phoneNumber
        },
        tokensPurchased: tokensPurchased || 0
      })
    })

    this.usub = this.props.me.observeUsage().subscribe(usage => {
      const { words } = usage
      this.setState({
        wordsUsed: words
      })
    })

    this.psub1 = this.props.me.observePurchases().subscribe(change => {
      const wordPack = change.wordPack
      if (change.type === 'removed') {
        delete this.purchases[wordPack.id]
      } else {
        this.purchases[wordPack.id] = wordPack
      }
      this.updateWordPacksLater()
    })
    
    this.buttonSub = this.props.me.observeMyButtons().subscribe(change => {
      const button = change.button
      if (change.type === 'removed') {
        delete this.buttons[button.id]
      } else {
        this.buttons[button.id] = button
      }
      this.updateButtonsLater()
    })

    this.statusMonitor = new HomeSubscriptionStatus({
      getSubscriptions: () => this.props.me.subscriptionProvidersStatus(),
      onChange: subscriptionStatus => this.setState({ subscriptionStatus })
    })
    this.statusAuthSub = this.props.me.observeSelf().subscribe(user => {
      this.statusMonitor.setAccount(user?.uid)
    })
    if (this.props.notEnoughTokens) {
      this.onNotEnoughTokens()
    }
  }

  onNotEnoughTokens = () => {
    
  }
               
  buttons = {}

  updateButtonsLater = () => {
    clearTimeout(this.buttonUpdater)
    this.buttonUpdater = setTimeout(this.updateButtonsNow, 200)
  }

  updateButtonsNow = () => {
    this.setState({
      buttons: Object.values(this.buttons)
    })
  }

  purchases = {}

  updateWordPacksLater = () => {
    clearTimeout(this.wordPackUpdater)
    this.wordPackUpdater = setTimeout(this.updateWordPacksNow, 200)
  }

  updateWordPacksNow = () => {
    const wordPacks = Object.values(this.purchases)
    let purchased = 0
    let nonFree = false
    for (const purchase of wordPacks) {
      purchased += tokenCountForPack(purchase)
      if (purchase.price > 0) {
        nonFree = true
      }
    }
    this.setState({
      wordPacks,
      wordsPurchased: purchased,
      nonFree
    })
  }
  
  signUp = async () => {
    const back = this.back
    this.setState({
      subpage: () => <KeyboardLogin me={this.props.me} safeArea={true} back={back}/>
    })
  }
  
  componentWillUnmount() {
    this.desktopReleaseMounted = false
    this.props.onCreate(null)
    if (super.componentWillUnmount) super.componentWillUnmount()
    if (this.psub) this.psub.unsubscribe()
    if (this.usub) this.usub.unsubscribe()
    if (this.buttonSub) this.buttonSub.unsubscribe()
    if (this.statusAuthSub) this.statusAuthSub.unsubscribe()
    if (this.statusMonitor) this.statusMonitor.stop()
  }
}
